import CustomButton from "../../../components/lib/customButton";

const ConfirmCloseView = ({ onCancel, onConfirm }) => {
    return (
        <div className="absolute inset-0 z-50 bg-white/90 backdrop-blur-sm flex items-center justify-center">

            <div className="bg-white rounded-xl shadow-xl p-6 w-full max-w-sm text-center space-y-4">

                <h3 className="text-lg font-semibold text-gray-800">
                    Deseja sair do cadastro?
                </h3>

                <p className="text-sm text-gray-500">
                    Existem dados preenchidos que serão perdidos se você sair agora.
                </p>

                <div className="flex justify-center gap-4 pt-4">
                    <CustomButton
                        buttonType="confirmLater"
                        text="Continuar editando"
                        showIcon={false}
                        onClick={onCancel}
                    />

                    <CustomButton
                        buttonType="cancel"
                        text="Sair e descartar"
                        showIcon={false}
                        onClick={onConfirm}
                    />
                </div>
            </div>
        </div>
    );
};

export default ConfirmCloseView;
